module.exports = __webpack_public_path__ + "img/container.218f9110.svg";